import { Component, Vue } from "vue-property-decorator"
import Tracking from "@/managers/session/logging/tracking"

@Component
export default class TrackingComponent extends Vue {
	protected $trackEvent(category: string, action: string, label?: string): void {
		Tracking.event(category, action, label)
	}
}
